/** 'done' | 'active' | 'new' — where a student stands on a course. */
export function courseState(solved, total) {
  if (total > 0 && solved >= total) return 'done';
  if (solved > 0) return 'active';
  return 'new';
}

export const STATE_LABEL = { done: 'courses.stateDone', active: 'courses.stateActive', new: 'courses.stateNew' };
export const STATE_TONE = { done: 'success', active: 'accent', new: undefined };

export function percentOf(solved, total) {
  return total > 0 ? Math.min(100, Math.round((solved / total) * 100)) : 0;
}
